import { InboxMessageResponse } from 'types/life';
import { changeDataFun } from 'utils/formate';

export interface InboxMessageProps {
  id: number;
  messageCategory: string;
  policyNo: string;
  messageTitle: string;
  message: string;
  messagePriority: number;
  effectiveDate: string;
  expiryDate?: string;
  createDate?: string;
  createUser: string;
  loginId: string;
  clientKey: string;
  buId: string;
  shownDate?: string;
  messageIcon?: string;
  category?: string;
}
const MAXIMUM_NUMBER_OF_NEWS = 5;

export const formatNotification = (
  notifications: InboxMessageResponse[] | undefined,
  isEnglish: boolean,
  //   token: string,
): InboxMessageProps[] | undefined => {
  if (!notifications) return undefined;
  const formattedNotifications = notifications.map((notification) => {
    const {
      id,
      messageCategory,
      policyNo,
      messageTitleEn,
      messageTitleZh,
      message,
      message_zh,
      messagePriority,
      effectiveDate,
      expiryDate,
      createDate,
      createUser,
      loginId,
      clientKey,
      buId,
      shownDate,
      messageIcon,
      categoryEn,
      categoryTc,
    } = notification;
    return {
      id,
      messageCategory,
      policyNo,
      message: isEnglish ? message : message_zh,
      messageTitle: isEnglish ? messageTitleEn : messageTitleZh,
      messagePriority,
      category: isEnglish ? categoryEn : categoryTc,
      effectiveDate,
      createUser,
      loginId,
      expiryDate: isEnglish ? expiryDate : changeDataFun(expiryDate),
      createDate: isEnglish ? createDate : changeDataFun(createDate),
      shownDate: isEnglish ? shownDate : changeDataFun(shownDate),
      clientKey,
      buId,
      messageIcon,
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedNotifications.slice(0, MAXIMUM_NUMBER_OF_NEWS);
};
